export const environment = {
  production: true,
  // ADMIN_API_URL: 'https://stagingapi.theminexchange.com/api/v1/admin/',
  ADMIN_API_URL: 'https://api.theminexchange.com/api/v1/admin/',
  ASSET_BASE_URL: 'https://api.theminexchange.com/api/v1/file-upload/',
  RAW_API_URL: 'https://api.theminexchange.com/api/v1/',
  // ASSET_BASE_URL: 'https://stagingapi.theminexchange.com/api/v1/file-upload/',
  // RAW_API_URL: 'https://stagingapi.theminexchange.com/api/v1/',
  ENCRYPT_LOCAL_STORAGE: true,
  LOCAL_STORAGE_SECRET: 'D96Q2M84E3400063E8366912AQ45488H',
  MAP_BOX_PUBLIC_KEY: 'pk.eyJ1Ijoia2VzYXYtc3BhcmtvdXQiLCJhIjoiY2xxYnhrbmVsMDVkODJrbzcyYmk1b2ZrOSJ9.eqRN_iBeEDzyWtx3r79bwQ',
};
